/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Direction } from './Direction';
import {
    DirectionFromJSON,
    DirectionFromJSONTyped,
    DirectionToJSON,
    DirectionToJSONTyped,
} from './Direction';

/**
 * Information about a single flight. E.g. the main/feeder flight
 * @export
 * @interface FlightSegment
 */
export interface FlightSegment {
    /**
     * 
     * @type {Direction}
     * @memberof FlightSegment
     */
    direction?: Direction;
    /**
     * Departure airport code
     * @type {string}
     * @memberof FlightSegment
     */
    depAirportCode?: string;
    /**
     * Departure airport name
     * @type {string}
     * @memberof FlightSegment
     */
    depAirportName?: string;
    /**
     * Indicates whether detailed information (e.g. dep/arr times, carrierCode, carriernumber, etc.) about the flight is available
     * @type {boolean}
     * @memberof FlightSegment
     */
    publish?: boolean;
    /**
     * Date of departure
     * @type {string}
     * @memberof FlightSegment
     */
    depDate?: string;
    /**
     * Time of departure
     * @type {string}
     * @memberof FlightSegment
     */
    depTime?: string;
    /**
     * Arrival airport code
     * @type {string}
     * @memberof FlightSegment
     */
    arrAirportCode?: string;
    /**
     * Arrival airport name
     * @type {string}
     * @memberof FlightSegment
     */
    arrAirportName?: string;
    /**
     * Date of arrival
     * @type {string}
     * @memberof FlightSegment
     */
    arrDate?: string;
    /**
     * Time of arrival
     * @type {string}
     * @memberof FlightSegment
     */
    arrTime?: string;
    /**
     * IATA airline code. This information is only available if publish is true
     * @type {string}
     * @memberof FlightSegment
     */
    carrierCode?: string;
    /**
     * Airline Name. This information is only available if publish is true
     * @type {string}
     * @memberof FlightSegment
     */
    carrierName?: string;
    /**
     * Flight number. This information is only available if publish is true
     * @type {string}
     * @memberof FlightSegment
     */
    carrierNumber?: string;
    /**
     * IATA airline code of airline that operates this flight. This information is only available if publish is true
     * @type {string}
     * @memberof FlightSegment
     */
    operatedBy?: string;
    /**
     * Airline Name of airline that operates this flight. This information is only available if publish is true
     * @type {string}
     * @memberof FlightSegment
     */
    operatedByName?: string;
    /**
     * Flight class
     * @type {string}
     * @memberof FlightSegment
     */
    flightClassCode?: string;
    /**
     * Name of flight class
     * @type {string}
     * @memberof FlightSegment
     */
    flightClassName?: string;
}



/**
 * Check if a given object implements the FlightSegment interface.
 */
export function instanceOfFlightSegment(value: object): value is FlightSegment {
    return true;
}

export function FlightSegmentFromJSON(json: any): FlightSegment {
    return FlightSegmentFromJSONTyped(json, false);
}

export function FlightSegmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightSegment {
    if (json == null) {
        return json;
    }
    return {
        
        'direction': json['direction'] == null ? undefined : DirectionFromJSON(json['direction']),
        'depAirportCode': json['depAirportCode'] == null ? undefined : json['depAirportCode'],
        'depAirportName': json['depAirportName'] == null ? undefined : json['depAirportName'],
        'publish': json['publish'] == null ? undefined : json['publish'],
        'depDate': json['depDate'] == null ? undefined : json['depDate'],
        'depTime': json['depTime'] == null ? undefined : json['depTime'],
        'arrAirportCode': json['arrAirportCode'] == null ? undefined : json['arrAirportCode'],
        'arrAirportName': json['arrAirportName'] == null ? undefined : json['arrAirportName'],
        'arrDate': json['arrDate'] == null ? undefined : json['arrDate'],
        'arrTime': json['arrTime'] == null ? undefined : json['arrTime'],
        'carrierCode': json['carrierCode'] == null ? undefined : json['carrierCode'],
        'carrierName': json['carrierName'] == null ? undefined : json['carrierName'],
        'carrierNumber': json['carrierNumber'] == null ? undefined : json['carrierNumber'],
        'operatedBy': json['operatedBy'] == null ? undefined : json['operatedBy'],
        'operatedByName': json['operatedByName'] == null ? undefined : json['operatedByName'],
        'flightClassCode': json['flightClassCode'] == null ? undefined : json['flightClassCode'],
        'flightClassName': json['flightClassName'] == null ? undefined : json['flightClassName'],
    };
}

export function FlightSegmentToJSON(json: any): FlightSegment {
    return FlightSegmentToJSONTyped(json, false);
}

export function FlightSegmentToJSONTyped(value?: FlightSegment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'direction': DirectionToJSON(value['direction']),
        'depAirportCode': value['depAirportCode'],
        'depAirportName': value['depAirportName'],
        'publish': value['publish'],
        'depDate': value['depDate'],
        'depTime': value['depTime'],
        'arrAirportCode': value['arrAirportCode'],
        'arrAirportName': value['arrAirportName'],
        'arrDate': value['arrDate'],
        'arrTime': value['arrTime'],
        'carrierCode': value['carrierCode'],
        'carrierName': value['carrierName'],
        'carrierNumber': value['carrierNumber'],
        'operatedBy': value['operatedBy'],
        'operatedByName': value['operatedByName'],
        'flightClassCode': value['flightClassCode'],
        'flightClassName': value['flightClassName'],
    };
}

